/* Emir ICE - Blog Luxe : apparition des cartes + recherche instantanee */
(function () {
function init() {
  var root = document.querySelector('[data-ei-blog]');
  if (!root || root.dataset.eiReady === '1') { return; }
  root.dataset.eiReady = '1';

  var cards = [].slice.call(root.querySelectorAll('[data-ei-card]'));

  /* Apparition progressive des cartes */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = (parseInt(el.dataset.eiOrder || '0', 10) % 3) * 90;
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    cards.forEach(function (el, i) { el.dataset.eiOrder = i; io.observe(el); });
  } else {
    cards.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Filtre instantané */
  var input = root.querySelector('[data-ei-search]');
  if (input) {
    var run = function () {
      var q = input.value.toLowerCase().trim();
      var shown = 0;
      cards.forEach(function (el) {
        var ok = q === '' || (el.getAttribute('data-search') || '').indexOf(q) !== -1;
        el.style.display = ok ? '' : 'none';
        if (ok) { shown++; el.classList.add('is-in'); }
      });
      root.classList.toggle('is-empty', shown === 0);
    };
    input.addEventListener('input', run);
    input.addEventListener('search', run);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
if (window.InstantClick) { window.InstantClick.on('change', init); }
  })();
